<template>
    <div :class="['prices', discountClass]">
        <span class="price_ref">{{ currency }} {{ ticketItem.price_ref }}</span>
        <span class="price">
            {{ currency }} {{ ticketItem.price }}
        </span>
    </div>
</template>

<style lang="scss" scoped>
    label.active .price_ref,
    td:hover label .price_ref {
        color: #FFF;
    }

    .prices {
        position: relative;

        &.price-discount .price_ref {
            display: block;
        }

        span {
            display: block;
            text-align: left;
        }

        .price_ref {
            display: none;
            position: absolute;
            top: -11px;
            font-size: 11px;
            color: var(--color-red);
            text-decoration: line-through;
            width: 100%;
            left: 1px;
        }
    }
</style>

<script>
    export default {
        props: {
            outlet: Boolean,
            promotionalInfo: Object,
            ticket: {
                type: Object,
                required: true,
            },
            currency: {
                type: String,
                required: true,
            },
        },

        data() {
            return {
                ticketItem: this.ticket
            }
        },

        computed: {
            discountClass() {
                return this.isValidPromocode() || this.outlet ? 'price-discount' : null
            }
        },

        methods: {
            isValidPromocode() {
                this.backupPrices()

                if (!this.promotionalInfo) {
                    this.setPrice() // 100%
                    return false
                }

                if (this.promotionalInfo.tickets.indexOf(this.ticket.id) !== -1) {
                    this.setPrice(this.promotionalInfo.discount, this.promotionalInfo.promo_type)
                    return true;
                }

                return false
            },

            backupPrices() {
                if (!this.ticketItem.pricesList) {
                    const { price, price_ref } = this.ticketItem
                    this.ticketItem.pricesList = { price, price_ref }
                }
            },

            setPrice(discount = 1, promoType = null) {
                const price = this.ticketItem.pricesList.price
                let priceWithDiscount

                if (promoType === 'fixed') {
                    // Fixed discount: subtract the discount amount
                    priceWithDiscount = Math.floor(price - discount)
                } else {
                    // Percent discount: multiply by the discount factor
                    priceWithDiscount = Math.floor(price * discount)
                }

                if (!this.outlet) {
                    this.ticketItem.price_ref = price
                }
                this.ticketItem.price = priceWithDiscount
            }
        }
    }
</script>
